// 报备状态列表
const reportStatusList = [
    {value: '', label: '全部报备状态'},
    {value: '1', label: '待审核'},
    {value: '2', label: '被驳回'},
    {value: '3', label: '待检查'},
    {value: '4', label: '初查通过'},
    {value: '5', label: '检查不通过'},
    {value: '6', label: '过期未检查'},
    {value: '7', label: '复查通过（检查合格）'},
    {value: '8', label: '复查未通过（检查不合格）'},
    {value: '9', label: '过期未复查'},
    {value: '10', label: '过期未审核'},
    {value: "11", label: "乡厨待接受"},
    {value: "12", label: "乡厨已驳回"}
]
// 办宴类型列表
const banquetTypeList = [
    {value: '', label: '全部办宴类型'},
    {value: '1', label: '红事'},
    {value: '2', label: '白事'},
    {value: '3', label: '生日'},
    {value: '4', label: '状元'},
    {value: '5', label: '乔迁'},
    {value: '6', label: '其他'}
]
const getWeekByDays = (days) => {
    if (typeof days !== 'number' && days % 1 !== 0) return ''
    let week = ''
    switch (days) {
        case 1:
            week = '星期一';
            break;
        case 2:
            week = '星期二';
            break;
        case 3:
            week = '星期三';
            break;
        case 4:
            week = '星期四';
            break;
        case 5:
            week = '星期五';
            break;
        case 6:
            week = '星期六';
            break;
        case 0:
            week = '星期日';
            break;
        default:
            week = ''
    }
    return week
}
// 处理两位数字
const dealTwoNumber = (towNumber) => {
    return towNumber >= 10 ? towNumber : `0` + towNumber
}
// 获取当前时间
const getCurrentDateTime = () => {
    let nowDate = new Date()
    let year = nowDate.getFullYear(),
        month = nowDate.getMonth(),
        day = nowDate.getDate(),
        hour = nowDate.getHours(),
        minutes = nowDate.getMinutes(),
        seconds = nowDate.getSeconds();
    document.getElementById('now-date-time').innerText = `${year}-${dealTwoNumber(month+1)}-${dealTwoNumber(day)} ${dealTwoNumber(hour)}:${dealTwoNumber(minutes)}:${dealTwoNumber(seconds)}`
}
export {
    reportStatusList,
    banquetTypeList,
    getWeekByDays,
    getCurrentDateTime
}
